@if (data()) {
  @let $selected = selectedCategory();

  <ng-template #headerEnd>
    <calcite-action scale="m" icon="refresh"
                    (click)="recalculate()" text="Refresh" text-enabled/>
  </ng-template>

  <stack direction="horizontal" transparent class="gap-1">
    <calcite-segmented-control scale="m" (calciteSegmentedControlChange)="setCategory($event.target.value)">
      @for (category of categories; track category.key) {
        @let categoryData = data()![category.key];
        <calcite-segmented-control-item
          [value]="category.key"
          [checked]="$selected === category.key"
        >
          {{ category.label }} ({{ categoryData?.length ?? 0 }})
        </calcite-segmented-control-item>
      }
    </calcite-segmented-control>

    <div><strong>{{ includedCount() }}/{{ totalCount() }} Selected</strong></div>
  </stack>

  @for (category of categories; track category.key) {
    @let categoryData = data()![category.key];
    <stack class="gap-1" transparent [class.app-hidden]="$selected !== category.key">
      @if (categoryData.length === 0) {
        <calcite-notice appearance="transparent">No qualifying comparables found</calcite-notice>
      } @else {
        @for (comp of categoryData; track comp.apn) {
          <app-comparable [comparable]="comp" (toggle)="toggleInclusion(comp, $event)"/>
        }
      }
    </stack>
  }
}
